/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * TSOA-compatible version of FunnelStatusChangedBySource.
 * Replaces Zod-inferred enum with explicit string literal union.
 */
export enum TCFunnelStatusChangedBySource {
    USER = 'USER',
    SYSTEM = 'SYSTEM',
    AI = 'AI',
}
